import { useState } from "react";
import type { PersistedForm } from "schemas";
import { Drawer, Loader, TextAccent, TextMain, flexStyles, paddingStyles } from "ui";
import { useForms } from "../../../../store";
import { Button, RadioCard } from "../../../ui";

interface Props {
  onClose: () => void;
  onFormSelected: (form: PersistedForm) => void;
}

export function FormLinkBlockDrawer({ onClose, onFormSelected }: Props) {
  const { forms, loading } = useForms();
  const [selectedForm, setSelectedForm] = useState<PersistedForm | null>(null);

  const handleSelectForm = (form: PersistedForm) => {
    setSelectedForm(form);
  };

  const handleSave = () => {
    if (selectedForm) {
      onFormSelected(selectedForm);
    }
  };

  if (loading) {
    return (
      <Drawer onClose={onClose} title="Select Form" open={true}>
        <Loader />
      </Drawer>
    );
  }

  return (
    <Drawer onClose={onClose} title="Select Form" open={true}>
      <div className={paddingStyles.py125}>
        <div className={flexStyles.vert125}>
          <TextMain>Choose a form to link</TextMain>

          <div className={flexStyles.vert050}>
            {forms.length === 0 ? (
              <>
                <TextAccent>No forms found</TextAccent>
                <Button to="/forms/new" buttonType="secondary">
                  Create a form first
                </Button>
              </>
            ) : (
              forms.map((form) => (
                <RadioCard
                  key={form.id}
                  onClick={() => handleSelectForm(form)}
                  title={<TextAccent>{form.name}</TextAccent>}
                  checked={selectedForm?.id === form.id}
                />
              ))
            )}
          </div>

          <div className={flexStyles.horiz025}>
            <Button onClick={handleSave} disabled={!selectedForm}>
              Insert Form
            </Button>
            <Button buttonType="tertiary" onClick={onClose}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </Drawer>
  );
}
